import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DeviceService } from 'src/app/core/device.service';
import { UserService } from 'src/app/core/user.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-upload-step',
  templateUrl: './upload-step.component.html',
  styleUrls: ['./upload-step.component.scss'],
  standalone: false
})
export class UploadStepComponent {

  @Input() form!: FormGroup;
  @Input() files: File[] = [];
  @Input() filesUploading: boolean = false;
  @Output() selectedFilesChange = new EventEmitter<File[]>();

  isUploadingFiles: boolean = false;

  user?: User;

  showRestrictionInfo: boolean = false;
  showPromptInput: boolean = false;

  deviceType?: string;

  constructor(
    private userService: UserService,
    private deviceService: DeviceService
  ) {}

  ngOnInit() {
    this.userService.getUser().subscribe((user) => this.user = user);

    this.deviceType = this.deviceService.getDeviceType();
  }

  async filesUploaded(uploadedFiles: any[]) {
    this.isUploadingFiles = true;
    this.files = uploadedFiles;
    await this.checkAndApplyRestriction(this.files);
    this.isUploadingFiles = false;
    this.selectedFilesChange.emit(this.files);
  }

  promptCheckboxValueChanged(value: boolean) {
    this.showPromptInput = value;
    this.form.get('prompt')?.setValidators(value ? [Validators.required] : []);
    this.form.get('prompt')?.updateValueAndValidity();
  }
  
  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }

  fileSelectionChanged(files: any): void {
    this.files = files;
    this.checkAndApplyRestriction(files);
    this.selectedFilesChange.emit(files);
  }

  checkAndApplyRestriction(files: any) {
    if (!files || files.length === 0) {
      this.showRestrictionInfo = false;
      return;
    }

    /*if (this.user?.isPremiumUser === false) {
      this.pdfService.getPdfPageCount(files[0]).then((num) => {
        if (num > 20) {
          this.showRestrictionInfo = true;
        }
      });
    } else {
      this.showRestrictionInfo = false;
    }*/
  }

  removeFile(file: File): void {
    this.files = this.files.filter(f => f !== file);
    this.fileSelectionChanged(this.files);
  }
}
